import { Thead, type StackProps } from '@chakra-ui/react';

export type UiTheadProps = StackProps;

export const UiThead = Thead;
